<template>
  <cx-multi-modules :module_id="345" />
</template>
<script>
export default { name: 'VxSynthesesGdtWk' }
</script>